<template>
    <footer class="green-earth-footer">
        <div class="green-earth-footer__inner">
            © 2026 PT SALAM PACIFIC INDONESIA LINES. All rights reserved
        </div>
    </footer>
</template>

<script setup>
</script>

<style scoped>
.green-earth-footer{
    background: #d1e7d9;
}

.green-earth-footer__inner {
    width: min(100%, 1920px);
    margin: 0 auto;
    min-height: 123px;
    border-radius: 40px 40px 0 0;
    background: linear-gradient(90deg, #3c9a49 0%, #2c8050 100%);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 24px 32px;
    font-size: 15px;
    line-height: 1.5;
    font-weight: 400;
    letter-spacing: 0.01em;
}

@media (max-width: 768px) {
    .green-earth-footer__inner {
        min-height: 96px;
        border-radius: 28px 28px 0 0;
        padding: 20px 16px;
        font-size: 13px;
    }
}
</style>